// extracted by mini-css-extract-plugin
module.exports = {"root":"cutOffText_root__mqMaJ","switcherContainer":"cutOffText_switcherContainer__pbSxr ml-1","switcher":"cutOffText_switcher__uDErA underline"};